import { Fragment } from 'react';

import { usePublishedTermsQuery } from '../hooks/use-published-terms';

interface RequiredTermsLinksProps {
  // Wrapper class (reuses the page's existing footer styling).
  className?: string;
  // Class for the `|` separators between links.
  sepClassName?: string;
}

// FEATURE_041 — renders one footer link per PUBLISHED term that is `required`. Labels come
// from the term name (BE ships Korean only). Data-driven: a term flipped to optional (or
// unpublished) automatically drops out. Non-critical ambient fetch — while loading, on error,
// or when there are no required terms, it renders nothing rather than blocking the page.
export const RequiredTermsLinks = ({ className, sepClassName }: RequiredTermsLinksProps) => {
  const { data } = usePublishedTermsQuery();

  const requiredTerms = (data ?? []).filter((term) => term.required);
  if (requiredTerms.length === 0) return null;

  return (
    <div className={className}>
      {requiredTerms.map((term, index) => (
        <Fragment key={term.termVersionId}>
          {index > 0 && <span className={sepClassName}>|</span>}
          <a href={`/terms?typeId=${term.typeId}`} target="_blank" rel="noopener noreferrer">
            {term.name}
          </a>
        </Fragment>
      ))}
    </div>
  );
};
